<div class="title">
  <p>{{ "COMMON.METER_ASSIGNMENT.SINGLE" | translate }}</p>
  <div class="title-actions">
    <button
      type="button"
      class="btn btn-secondary me-2"
      (click)="toggleAll()"
      *ngIf="meterAssignments.length > 0 && permissionsService.isMeterAssignmentCreateEditAllowed"
    >
      {{ (globalIsDisabled ? "COMMON.METER_ASSIGNMENT.TURN_ON_CONFIG" : "COMMON.METER_ASSIGNMENT.TURN_OFF_CONFIG") | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#addEditMeterAssignment"
      (click)="addNew()"
      *ngIf="utilityId != 0 && bpsAdminLevel != 2 && permissionsService.isMeterAssignmentCreateEditAllowed"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8 0C7.4477 0 7 0.44772 7 1V7H1C0.44772 7 0 7.4477 0 8C0 8.5523 0.44772 9 1 9H7V15C7 15.5523 7.4477 16 8 16C8.5523 16 9 15.5523 9 15V9H15C15.5523 9 16 8.5523 16 8C16 7.4477 15.5523 7 15 7H9V1C9 0.44772 8.5523 0 8 0Z"
          fill="white" />
      </svg>
      {{ "CRUD_SETTINGS.ADD_NEW" | translate }}
    </button>
  </div>
</div>

<div class="container-fluid border-bottom">
  <table>
    <tr class="header-row">
      <th>{{ "COMMON.PROJECT_DESIGNATION.PROJECT_TYPE" | translate | uppercase }}</th>
      <th>{{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate | uppercase }}</th>
      <th>{{ "NEW_SERVICE.FEEDER_BAND" | translate | uppercase }}</th>
      <th>{{ "NEW_SERVICE.SERVICE_REQUEST_TYPE" | translate | uppercase }}</th>
      <th>{{ "COMMON.METER_ASSIGNMENT.METER_TYPE" | translate | uppercase }}</th>
      <th>{{ "COMMON.METER_ASSIGNMENT.MAP_VENDOR" | translate | uppercase }}</th>
      <th>{{ "COMMON.STATUS" | translate | uppercase }}</th>
      <th></th>
    </tr>
    <tr
      class="content-wrapper"
      *ngFor="let item of meterAssignments"
      (click)="openEditModal(item)"
    >
      <td>{{ getProjectTypeName(item.projectType) }}</td>
      <td>{{ getProjectDesignationName(item.projectDesignationId) }}</td>
      <td>{{ getFeederBandNames(item.feederBands) }}</td>
      <td>{{ getServiceRequestTypeNames(item.serviceRequestTypes) }}</td>
      <td>{{ getMeterTypeNames(item.meterTypes) }}</td>
      <td>{{ getOrganizationNames(item.organizationIds) }}</td>
      <td>
        <span
          class="status-badge"
          [ngClass]="item.isDisabled ? 'status-off' : 'status-on'"
          (click)="toggleStatus(item, $event)"
          *ngIf="permissionsService.isMeterAssignmentCreateEditAllowed"
        >
          {{ (item.isDisabled ? "COMMON.METER_ASSIGNMENT.OFF" : "COMMON.METER_ASSIGNMENT.ON") | translate }}
        </span>
        <span *ngIf="!permissionsService.isMeterAssignmentCreateEditAllowed">
          {{ (item.isDisabled ? "COMMON.METER_ASSIGNMENT.OFF" : "COMMON.METER_ASSIGNMENT.ON") | translate }}
        </span>
      </td>
      <td class="td-svg">
        <svg
          data-bs-toggle="modal"
          data-bs-target="#deleteMeterAssignment"
          (click)="selectItem(item); $event.stopPropagation()"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="bpsAdminLevel != 2 && permissionsService.isMeterAssignmentDeleteAllowed"
        >
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#DE350B" />
        </svg>
      </td>
    </tr>
  </table>
</div>

<div>
  <app-paging
    *ngIf="count > 0"
    [pageSize]="pageSize"
    [count]="count"
    [currentPage]="currentPage"
    (pageChange)="pageChange($event)"
  ></app-paging>
</div>

<button #openEditModalBtn hidden data-bs-toggle="modal" data-bs-target="#addEditMeterAssignment"></button>

<!-- Add/Edit Modal -->
<div class="modal fade" id="addEditMeterAssignment" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ (isEditMode ? "COMMON.EDIT" : "COMMON.NEW") | translate }}
          {{ "COMMON.METER_ASSIGNMENT.SINGLE" | translate }}
        </h5>
        <button type="button" #closeAddEditModal class="btn-cancel-modal" data-bs-dismiss="modal">
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <form id="meterAssignmentForm" class="form-wrapper" ngNativeValidate (submit)="save()">
        <div class="modal-body">

          <!-- Project Type -->
          <div class="form-item form-floating mb-3">
            <select
              class="form-select"
              name="selectProjectType"
              [(ngModel)]="selectedProjectType"
              [ngClass]="selectedProjectType != undefined ? 'selected-option' : ''"
            >
              <option [ngValue]="undefined" disabled class="dropdown-item">
                {{ "COMMON.PROJECT_DESIGNATION.PROJECT_TYPE" | translate }}
              </option>
              <option *ngFor="let pt of projectTypes" [ngValue]="pt.id">{{ pt.name }}</option>
            </select>
            <label *ngIf="selectedProjectType != undefined" class="label-for-select">
              {{ "COMMON.PROJECT_DESIGNATION.PROJECT_TYPE" | translate }}
            </label>
          </div>

          <!-- Project Designation -->
          <div class="form-item form-floating mb-3">
            <select
              class="form-select"
              name="selectProjectDesignation"
              [(ngModel)]="selectedProjectDesignationId"
              [ngClass]="selectedProjectDesignationId != null ? 'selected-option' : ''"
            >
              <option [ngValue]="null" class="dropdown-item">
                {{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate }} ({{ "COMMON.OPTIONAL" | translate }})
              </option>

              <option *ngFor="let pd of projectDesignations" [ngValue]="pd.id">{{ pd.name }}</option>
            </select>
            <label *ngIf="selectedProjectDesignationId != null" class="label-for-select">
              {{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate }}
            </label>
          </div>

          <!-- Feeder Band -->
          <div class="multi-select-group">
            <app-multi-select-dropdown
              [clicked]="clicked"
              [items]="feederBandItems"
              [label]="'NEW_SERVICE.FEEDER_BAND' | translate"
              [showMore]="false"
              [requireApply]="false"
              (shareIndividualCheckedList)="onFeederBandChange($event)"
            ></app-multi-select-dropdown>
          </div>

          <!-- Service Request Type -->
          <div class="multi-select-group">
            <app-multi-select-dropdown
              [clicked]="clicked"
              [items]="serviceRequestTypeItems"
              [label]="'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate"
              [showMore]="false"
              [requireApply]="false"
              (shareIndividualCheckedList)="onServiceRequestTypeChange($event)"
            ></app-multi-select-dropdown>
          </div>

          <!-- Meter Type -->
          <div class="multi-select-group">
            <app-multi-select-dropdown
              [clicked]="clicked"
              [items]="meterTypeItems"
              [label]="'COMMON.METER_ASSIGNMENT.METER_TYPE' | translate"
              [showMore]="false"
              [requireApply]="false"
              (shareIndividualCheckedList)="onMeterTypeChange($event)"
            ></app-multi-select-dropdown>
          </div>

          <!-- MAP Vendor -->
          <div class="multi-select-group">
            <app-multi-select-dropdown
              [clicked]="clicked"
              [items]="organizationItems"
              [label]="'COMMON.METER_ASSIGNMENT.MAP_VENDOR' | translate"
              [showMore]="false"
              [requireApply]="false"
              (shareIndividualCheckedList)="onOrganizationChange($event)"
            ></app-multi-select-dropdown>
          </div>

        </div>
        <div class="modal-footer" *ngIf="bpsAdminLevel != 2">
          <button class="btn btn-primary" form="meterAssignmentForm">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<div class="modal fade" id="deleteMeterAssignment" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.METER_ASSIGNMENT.SINGLE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="deleteItem()">
          {{ "COMMON.DELETE" | translate }}
        </button>
        <button #closeDeleteModal hidden="true" data-bs-dismiss="modal"></button>
      </div>
    </div>
  </div>
</div>
